import qs from "qs";

export function toParams(obj) {
  /*
    Input
      obj = {a:1, b:2, c=3 ...}

    Output
      return '?a=1&b=2&c=3'

    Comment
      easy way to make Object to Parameters
  */
  return qs.stringify(obj);
}

export const commonFunctions = {
  toParams(val) {
    return toParams(val);
  },
  copy(val) {
    return JSON.parse(JSON.stringify(val));
  },
  popById(array, id) {
    let idx = array.findIndex((item) => {
      return item.id == id;
    });
    if (idx > -1) array.splice(idx, 1);
  },
  popByData(array, data) {
    let idx = array.findIndex((item) => {
      return item == data;
    });
    if (idx > -1) array.splice(idx, 1);
  },
  comma(val, type = "Number") {
    if (val == 0) return 0;

    // float to int
    if (isNaN(Number(val))) {
      // Comma 가 들어있는 데이터의 경우
      if (isNaN(Number(String(val).replace(",", "")))) {
        return val; //숫자가 아닌 데이터가 들어올 경우 그대로 return
      } else {
        val = String(val).replace(",", "");
      }
    }
    if (val != "" && val != null && val != undefined) {
      val = Number(val);
      if (type == "Number") {
        val = parseInt(val);
      } else {
        val = parseFloat(val).toFixed(1);
      }
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    return val;
  },
  commaTrim(val, type = "Number") {
    if (!val) return "";

    // 숫자를 제외한 문자열 제거
    if (isNaN(Number(val) && val)) {
      const parts = val.split(".");
      if (parts.length > 1) {
        val = parts[0];
      }

      val = val.replace(/[^0-9]/g, "");
    }
    return this.comma(val, type);
  },
  dateFormat(val) {
    /** yyyymmdd 값을 yyyy-mm-dd로 바꿔준다. */
    if (val != "" && val != null && val != undefined) {
      val = Number(val);
      return String(val).replace(/(\d{4})(\d{2})(\d{2})/g, "$1-$2-$3");
    }
  },
  sortObject(list, sortBy) {
    let sortedKeys = Object.keys(list).sort(function (a, b) {
      return list[a][sortBy] - list[b][sortBy];
    });

    let sortedList = {};

    sortedKeys.forEach((key) => {
      sortedList[key] = list[key];
    });
    return sortedList;
  },
  sortByKey(arr, key, reverse = false) {
    return arr.sort(function (a, b) {
      var keyA = new Date(a[key]),
        keyB = new Date(b[key]);

      if (reverse) {
        if (keyA < keyB) return 1;
        if (keyA > keyB) return -1;
      } else {
        if (keyA < keyB) return -1;
        if (keyA > keyB) return 1;
      }
      // Compare the 2 dates

      return 0;
    });
  },
  getByteText(bytes) {
    if (bytes >= 1073741824) {
      bytes = (bytes / 1073741824).toFixed(2) + " GB";
    } else if (bytes >= 1048576) {
      bytes = (bytes / 1048576).toFixed(2) + " MB";
    } else if (bytes >= 1024) {
      bytes = (bytes / 1024).toFixed(2) + " KB";
    } else if (bytes > 1) {
      bytes = bytes + " bytes";
    } else if (bytes == 1) {
      bytes = bytes + " byte";
    } else {
      bytes = "0 bytes";
    }
    return bytes;
  },
  iconByType(type) {
    let icon;
    try {
      icon = require(`@/assets/images/icon/filetype/${type}.png`);
    } catch {
      icon = require(`@/assets/images/icon/filetype/else.png`);
    }
    return icon;
  },
  dateParsing(val, option) {
    if (!val) return "";

    let temp = String(val);
    let tempOption = option;
    let year = "",
      month = "",
      day = "";

    // 0. remove Exception
    [".", "-"].forEach((v) => {
      let tempSplit = temp.split(v);
      if (tempSplit.length > 1) {
        tempSplit.forEach((v2, idx) => {
          if (v2.length == 1) {
            tempSplit[idx] = `0${v2}`;
          }
        });
        temp = tempSplit.join("");
      }
    });

    var regex = /[^0-9]/g; // 숫자가 아닌 문자열을 선택 정규식
    temp = temp.replace(regex, "");

    // remove Exception: 20160426091438, 2018.8.31 23:59  ..
    if (temp.length > 8) {
      temp = temp.slice(0, 8);
    }

    if (temp.length == 8) {
      year = temp.slice(0, 4);
      month = temp.slice(4, 6);
      day = temp.slice(6, 8);
    } else if (temp.length == 6) {
      year = temp.slice(0, 4);
      month = temp.slice(4, 6);

      // If 17.12.22
      if (
        Number(year) < 1900 ||
        (Number(year) < 2000 && (Number(month) > 12 || Number(month) == 0))
      ) {
        year = "20" + temp.slice(0, 2);
        month = temp.slice(2, 4);
        day = temp.slice(4, 6);
      }
    } else if (temp.length == 4) {
      year = temp.slice(0, 4);
    } else {
      console.log("Exception Occur ", val, " CASE 1");
      return val;
    }

    try {
      if (year && !(Number(year) > 1800 && Number(year) < 3000)) {
        year = "";
      }

      if (month && !(Number(month) > 0 && Number(month) < 13)) {
        month = "";
      }

      if (day && !(Number(day) > 0 && Number(day) < 32)) {
        day = "";
      }
    } catch {
      console.log("Exception Occur ", val, " CASE 2");
      return val;
    }

    if (year) tempOption = tempOption.replace("YYYY", year);
    if (month) tempOption = tempOption.replace("MM", month);
    if (day) tempOption = tempOption.replace("DD", day);

    tempOption = tempOption
      .replace("YYYY", "")
      .replace("MM", "")
      .replace("DD", "");

    var isNum = /\d/;

    for (var i = 1; i < tempOption.length; i++) {
      let isNotNum = !isNum.test(tempOption[tempOption.length - 1]);
      let isNotNum2 = !isNum.test(tempOption[tempOption.length - 2]);
      if ([".", "-"].includes(tempOption[tempOption.length - 1])) {
        tempOption = tempOption.slice(0, tempOption.length - 1);
      } else if (isNotNum && isNotNum2) {
        tempOption = tempOption.slice(0, tempOption.length - 1);
      } else {
        break;
      }
    }
    if (tempOption.length < 2) {
      console.log("Exception Occur ", val, " CASE 3");
      return val;
    }
    return tempOption;
  },
  isMobile() {
    return isIOS() || isAndroid() || isSmallScreen();
  }
};


const isIOS = () => {
  return /iPad|iPhone/.test(navigator.userAgent);
};

const isAndroid = () => {
  return /Android/.test(navigator.userAgent);
};

const isSmallScreen = () => {
  return window.innerWidth < 500;
};

